function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  transform: "translate(-1540.5 -609.5)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M1557.639,609.5h-13.017a4.122,4.122,0,0,0-4.122,4.123v13.017a4.122,4.122,0,0,0,4.122,4.123h13.017a4.122,4.122,0,0,0,4.123-4.123V613.623A4.122,4.122,0,0,0,1557.639,609.5Zm.766,17.139a.767.767,0,0,1-.766.765h-13.017a.766.766,0,0,1-.765-.765V613.623a.767.767,0,0,1,.765-.766h13.017a.767.767,0,0,1,.766.766Z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1580.639,609.5h-13.017a4.122,4.122,0,0,0-4.123,4.123v13.017a4.122,4.122,0,0,0,4.123,4.123h13.017a4.122,4.122,0,0,0,4.123-4.123V613.623A4.122,4.122,0,0,0,1580.639,609.5Zm.766,17.139a.767.767,0,0,1-.766.765h-13.017a.766.766,0,0,1-.765-.765V613.623a.767.767,0,0,1,.765-.766h13.017a.767.767,0,0,1,.766.766Z",
  transform: "translate(2.738)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1557.639,632.5h-13.017a4.122,4.122,0,0,0-4.122,4.123v13.017a4.122,4.122,0,0,0,4.122,4.123h13.017a4.122,4.122,0,0,0,4.123-4.123V636.623A4.122,4.122,0,0,0,1557.639,632.5Zm.766,17.139a.767.767,0,0,1-.766.765h-13.017a.766.766,0,0,1-.765-.765V636.623a.766.766,0,0,1,.765-.765h13.017a.767.767,0,0,1,.766.765Z",
  transform: "translate(0 2.738)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1580.639,632.5h-13.017a4.122,4.122,0,0,0-4.123,4.123v13.017a4.122,4.122,0,0,0,4.123,4.123h13.017a4.122,4.122,0,0,0,4.123-4.123V636.623A4.122,4.122,0,0,0,1580.639,632.5Zm.766,17.139a.767.767,0,0,1-.766.765h-13.017a.766.766,0,0,1-.765-.765V636.623a.767.767,0,0,1,.765-.765h13.017a.767.767,0,0,1,.766.765Z",
  transform: "translate(2.738 2.738)"
}));

var SvgMosaic = function SvgMosaic(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 47,
    height: 47,
    viewBox: "0 0 47 47",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgMosaic, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/mosaic.d6c118b1.svg";
export { ForwardRef as ReactComponent };